import { RIF } from "../../lib";
import { useSelectTheme } from "../../store";
import { QuestionnaireTempQuestion } from "../../model";
import { QuestionnaireQuestionType } from "../../shared/db";

export const QuestionnaireOtherOption = (props: {
  question: QuestionnaireTempQuestion;
  isEditing: boolean;
}) => {
  const { color } = useSelectTheme();
  const { question, isEditing } = props;

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        height: isEditing ? "40px" : "auto",
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      <div
        css={{
          width: "16px",
          height: "16px",
          borderRadius: question?.type === QuestionnaireQuestionType.Radio ? "50%" : "2px",
          border: `1px solid ${color.grey_400}`,
          marginLeft: isEditing ? "24px" : "0",
        }}
      />
      {RIF(
        isEditing,
        <div
          css={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flex: 1,
          }}
        >
          <p
            css={{
              display: "flex",
              alignItems: "center",
              height: "40px",
              flex: 1,
              paddingLeft: "16px",
              color: color.textIcon.secondary,
              fontStyle: "italic",
              borderBottom: `1px dashed ${color.border.default}`,
            }}
          >
            {question.inputConfig?.customOtherName || "Other"}
          </p>
        </div>,
      )}
      {RIF(!isEditing, <p>{question.inputConfig?.customOtherName || "Other"}</p>)}
    </div>
  );
};
